/* Bean Shipper — Fresh landing v3 (15 Oct 2026). Behaviour for sections/page__bs-fresh-x.liquid on
   /pages/fresh and /en-sg/pages/fresh-sg: size and grind (the form's variant id, every price label, the
   headline per-cup, the free-shipping meter, the delivered line), ?variant= preselect for ad links, the
   sticky bar, the cold-traffic flag, and the motion (scroll reveals, roast-date track, taste hotspots,
   stage tilt and depth, review-wall depth, one-open accordion). Content only ever moves, never fades; the
   page is complete without any of this. The add itself is the theme's ajax cart:
   form[data-bs-add] + [data-bs-pdp-add].
   27 Oct 2026: two coffees (each [data-bsfx-coffee] button carries its own vmap and owns one
   [data-bsfx-sizes] group; the root's data-bsfx-on says which shows), ?coffee= for ad links, the taste
   cards' "Choose" buttons, and the Hong Kong courier line (data-mkt="hk", priced per size).
   Long layout (.bsfx--long, /pages/roasted-to-order): the headline per-cup counts up from zero on load and
   the hero's bean orbits follow the pointer (--mx/--my on the stage). */
(function () {
  'use strict';

  function qsa(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }
  function mm(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }

  function init() {
    var root = document.querySelector('[data-bsfx]');
    if (!root || root.__bsfx) return;
    root.__bsfx = true;
    root.classList.add('is-js');

    var reduce = mm('(prefers-reduced-motion: reduce)');
    var fine = mm('(hover: hover) and (pointer: fine)');
    var hasIO = 'IntersectionObserver' in window;
    var sg = root.getAttribute('data-sg') === 'true';
    var mkt = root.getAttribute('data-mkt') || (sg ? 'sg' : 'my');
    var intl = root.getAttribute('data-intl') === 'true' || sg;
    var hkFree = root.getAttribute('data-hk-free') || '';
    var freeFrom = parseInt(root.getAttribute('data-free-from'), 10) || 8000;
    // 2 Nov 2026: the Bahasa Melayu page (page__bs-fresh-x-ms) sets its labels on the form as JSON in data-bsfx-l.
    // Without it every label below stays English, exactly as before.
    var LL = {};
    try { LL = JSON.parse(root.getAttribute('data-bsfx-l') || '{}') || {}; } catch (e) { LL = {}; }
    function L(k, d) { return typeof LL[k] === 'string' ? LL[k] : d; }

    // Cold traffic: no subscription pitch in the cart drawer for the rest of this session (Kai,
    // 28 Sep 2026). The drawer snippet reads the flag on every page; sessionStorage survives a
    // declined cookie banner, the cookie is the backup.
    document.documentElement.classList.add('bs-cold');
    try { sessionStorage.setItem('bs_cold', '1'); } catch (e) {}
    try { document.cookie = 'bs_cold=1; path=/; SameSite=Lax'; } catch (e) {}

    var idInput = root.querySelector('[data-bsfx-id]');
    function parseVmap(str) {
      return (str || '').split('||').map(function (e) {
        var p = e.split('~');
        return { id: p[0], size: p[1], grind: p[2], avail: p[3] === 'true' };
      }).filter(function (v) { return v.id; });
    }
    var coffeeBtns = qsa(root, '[data-bsfx-coffee]');
    var vmaps = {};
    coffeeBtns.forEach(function (b) { vmaps[b.getAttribute('data-bsfx-coffee')] = parseVmap(b.getAttribute('data-vmap')); });
    var coffee = root.getAttribute('data-bsfx-on') || '1';
    var variants = vmaps[coffee] || parseVmap(root.getAttribute('data-vmap'));
    var sizeBtns = qsa(root, '[data-bsfx-size]');
    var grindBtns = qsa(root, '[data-bsfx-grind]');
    var gchips = qsa(root, '.bsfx-gchip');
    var grindRow = root.querySelector('.bsfx-grinds');
    var pcEl = root.querySelector('[data-bsfx-pc]');
    var fill = root.querySelector('[data-bsfx-fill]');
    var meterText = root.querySelector('[data-bsfx-meter-text]');
    var meterBase = meterText ? meterText.textContent : '';
    var delivEl = root.querySelector('[data-bsfx-deliv]');
    var brewSet = root.querySelector('[data-bsfx-brewset]');
    var sticky = root.querySelector('[data-bsfx-sticky]');
    var stickyLabel = root.querySelector('[data-bsfx-sticky-label]');
    var stickyBtn = sticky ? sticky.querySelector('button') : null;
    var submits = qsa(root, '[data-bs-pdp-add]');
    var firstGrind = gchips.length ? gchips[0].getAttribute('data-bsfx-grind') : '';

    var current = null;
    variants.forEach(function (v) { if (idInput && v.id === idInput.value) current = v; });
    if (!current && variants.length) current = variants[0];
    if (!current) return;
    var state = { size: current.size, grind: current.grind };

    function findVariant(size, grind) {
      var i;
      for (i = 0; i < variants.length; i++) if (variants[i].size === size && variants[i].grind === grind) return variants[i];
      for (i = 0; i < variants.length; i++) if (variants[i].size === size) return variants[i];
      // A coffee without that size: its first bag that is in stock.
      for (i = 0; i < variants.length; i++) if (variants[i].avail) return variants[i];
      return variants[0] || null;
    }
    function sizeBtn(size) {
      var own = qsa(root, '[data-bsfx-sizes="' + coffee + '"] [data-bsfx-size]');
      if (!own.length) own = sizeBtns;
      for (var i = 0; i < own.length; i++) if (own[i].getAttribute('data-bsfx-size') === size) return own[i];
      return null;
    }
    function money(c) {
      var i = Math.floor(c / 100), s = c % 100;
      return 'RM' + i + (s ? '.' + (s < 10 ? '0' : '') + s : '');
    }
    function tick(el) {
      if (!el || reduce) return;
      el.classList.remove('bsfx-tick');
      void el.offsetWidth;
      el.classList.add('bsfx-tick');
    }

    // Headline per-cup follows the chosen size, eased between the two figures.
    var tweenId = 0;
    function tweenPc(to) {
      if (!pcEl || !to) return;
      var m = /^(\D*)(\d+(?:\.\d+)?)(.*)$/.exec(to);
      var cur = /^(\D*)(\d+(?:\.\d+)?)/.exec(pcEl.textContent);
      if (!m || !cur || reduce) { pcEl.textContent = to; return; }
      var a = parseFloat(cur[2]), b = parseFloat(m[2]), dec = (m[2].split('.')[1] || '').length, t0 = 0, id = ++tweenId;
      if (a === b) { pcEl.textContent = to; return; }
      function step(ts) {
        if (id !== tweenId) return;
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / 560), e = 1 - Math.pow(1 - k, 3);
        pcEl.textContent = m[1] + (a + (b - a) * e).toFixed(dec) + m[3];
        if (k < 1) requestAnimationFrame(step); else pcEl.textContent = to;
      }
      requestAnimationFrame(step);
      // rAF can stall in throttled or occluded webviews: never leave the old figure on the headline.
      setTimeout(function () { if (id === tweenId) pcEl.textContent = to; }, 700);
    }

    function apply(fromUser) {
      var v = findVariant(state.size, state.grind);
      if (!v) return;
      state.size = v.size;
      state.grind = v.grind;
      if (idInput) idInput.value = v.id;
      sizeBtns.forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-bsfx-size') === v.size ? 'true' : 'false'); });
      grindBtns.forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-bsfx-grind') === v.grind ? 'true' : 'false'); });
      var info = sizeBtn(v.size);
      if (!info) return;
      var price = info.getAttribute('data-price') || '';
      var cents = parseInt(info.getAttribute('data-cents'), 10) || 0;
      var free = info.getAttribute('data-free') === '1';

      tweenPc(intl ? info.getAttribute('data-pcs') : info.getAttribute('data-pc'));
      if (fill) fill.style.setProperty('--p', Math.min(1, cents / freeFrom).toFixed(3));
      if (meterText) {
        var t;
        if (mkt === 'hk') t = free ? L('hk_free', 'free courier to Hong Kong') : L('hk_pre', '') + (info.getAttribute('data-ship') || '') + L('hk_post', ' courier to Hong Kong') + (hkFree ? L('hk_from', ', free from ') + hkFree : '');
        else if (sg) t = free ? L('sg_free', 'free courier to Singapore') : meterBase;
        else t = free ? L('my_free', 'ships free in Peninsular Malaysia') : money(freeFrom - cents) + L('gap_post', ' to free shipping');
        if (meterText.textContent !== t) { meterText.textContent = t; if (fromUser) tick(meterText); }
      }
      if (delivEl) {
        var d = info.getAttribute('data-deliv') + L('deliv_post', ' delivered');
        if (delivEl.textContent !== d) { delivEl.textContent = d; if (fromUser) tick(delivEl); }
      }
      // Re-query: the ajax cart restores each button's innerHTML after an add.
      qsa(root, '[data-bsfx-btnlabel]').forEach(function (l) {
        var txt = v.avail ? L('add', 'Add to bag') + ' · ' + price : L('sold', 'Sold out');
        if (l.textContent !== txt) { l.textContent = txt; if (fromUser) tick(l); }
      });
      submits.forEach(function (b) { b.disabled = !v.avail; });
      if (stickyBtn) stickyBtn.textContent = v.avail ? L('add', 'Add to bag') : L('sold', 'Sold out');
      if (stickyLabel) stickyLabel.textContent = info.getAttribute('data-name') + ' · ' + price;
      if (brewSet) {
        var gName = (LL.g && typeof LL.g[v.grind] === 'string') ? LL.g[v.grind] : v.grind;
        var bs = v.grind === firstGrind ? L('set_pre', 'Set to ') + gName + L('set_whole', '. Grind just before you brew.') : L('set_pre', 'Set to ') + gName + L('set_ground', '. We grind it to order, same price.');
        if (brewSet.textContent !== bs) { brewSet.textContent = bs; if (fromUser) tick(brewSet.parentNode); }
      }
      if (grindRow) {
        gchips.forEach(function (c) {
          if (c.getAttribute('data-bsfx-grind') === v.grind && (c.offsetLeft < grindRow.scrollLeft || c.offsetLeft + c.offsetWidth > grindRow.scrollLeft + grindRow.clientWidth)) {
            grindRow.scrollTo({ left: Math.max(0, c.offsetLeft - 12), behavior: reduce ? 'auto' : 'smooth' });
          }
        });
      }
    }

    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () { state.size = b.getAttribute('data-bsfx-size'); apply(true); });
    });

    // Coffee switch: swap the vmap and the size cards, keep the size and grind where the other coffee
    // has them. The stage bag, note chips, proof line and sticky title follow data-bsfx-on in CSS.
    function setCoffee(k, fromUser) {
      if (!vmaps[k]) return;
      coffee = k;
      variants = vmaps[k];
      root.setAttribute('data-bsfx-on', k);
      coffeeBtns.forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-bsfx-coffee') === k ? 'true' : 'false'); });
      apply(fromUser);
    }
    coffeeBtns.forEach(function (b) {
      b.addEventListener('click', function () { setCoffee(b.getAttribute('data-bsfx-coffee'), true); });
    });
    // "Choose" on a taste card: switch the buy box, then bring it into view with a small nudge.
    qsa(root, '[data-bsfx-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        setCoffee(b.getAttribute('data-bsfx-pick'), true);
        var panel = root.querySelector('.bsfx-panel');
        if (!panel) return;
        try { panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (e) { panel.scrollIntoView(); }
        if (reduce) return;
        panel.classList.remove('is-nudge');
        void panel.offsetWidth;
        panel.classList.add('is-nudge');
      });
    });
    grindBtns.forEach(function (b) {
      b.addEventListener('click', function () { state.grind = b.getAttribute('data-bsfx-grind'); apply(true); });
    });

    // ?coffee= (a coffee's handle, or 1 / 2) and ?variant= (a variant id of either coffee, or
    // 300g / 2x300g / 1kg) for ad links.
    var startCoffee = coffee;
    try {
      var sp = new URLSearchParams(window.location.search);
      var qc = (sp.get('coffee') || '').toLowerCase();
      if (qc) coffeeBtns.forEach(function (b) {
        if (b.getAttribute('data-handle') === qc || b.getAttribute('data-bsfx-coffee') === qc) startCoffee = b.getAttribute('data-bsfx-coffee');
      });
      var q = sp.get('variant');
      if (q) {
        var hit = null;
        Object.keys(vmaps).forEach(function (k) { vmaps[k].forEach(function (v) { if (v.id === q) { hit = v; startCoffee = k; } }); });
        if (!hit) variants.forEach(function (v) { if (v.id === q) hit = v; });
        if (hit) { state.size = hit.size; state.grind = hit.grind; }
        else {
          var want = q.toLowerCase().replace(/\s+/g, '').replace('×', 'x');
          sizeBtns.some(function (b) {
            var key = b.getAttribute('data-bsfx-size').split(' - ')[0].toLowerCase().replace(/\s+/g, '');
            if (key === want) { state.size = b.getAttribute('data-bsfx-size'); return true; }
            return false;
          });
        }
      }
    } catch (e) {}
    if (coffeeBtns.length && startCoffee !== coffee) setCoffee(startCoffee, false);
    else apply(false);

    // Sticky bar: on once the hero button has scrolled above the viewport, off at the closing button.
    var mainBtn = root.querySelector('[data-bsfx-main]');
    var closeBtn = root.querySelector('[data-bsfx-close]');
    var pastMain = false, atClose = false;
    function paintSticky() {
      if (!sticky) return;
      var on = pastMain && !atClose;
      sticky.setAttribute('data-on', on ? 'true' : 'false');
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
    }
    if (sticky && mainBtn) {
      /* 19 Oct 2026: read both positions on scroll. With IntersectionObserver, a fast flick back up past
         the closing button skipped its "visible" frame, atClose stayed true and the bar never returned. */
      var stickyRaf = 0;
      var readSticky = function () {
        stickyRaf = 0;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        pastMain = mainBtn.getBoundingClientRect().bottom < 0;
        atClose = closeBtn ? closeBtn.getBoundingClientRect().top < vh : false;
        paintSticky();
      };
      var queueSticky = function () { if (!stickyRaf) stickyRaf = requestAnimationFrame(readSticky); };
      window.addEventListener('scroll', queueSticky, { passive: true });
      window.addEventListener('resize', queueSticky);
      readSticky();
    }

    // Scroll reveals: IntersectionObserver at threshold 0, plus a sweep after each scroll settles
    // as a backstop. Unrevealed blocks rest 26px low, fully visible.
    var rvs = qsa(root, '.bsfx-rv');
    var onReveal = [];
    function reveal(el) {
      if (el.classList.contains('is-in')) return;
      el.classList.add('is-in');
      onReveal.forEach(function (f) { f(el); });
    }
    if (reduce || !hasIO) {
      rvs.forEach(reveal);
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting || e.boundingClientRect.top < 0) { reveal(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      rvs.forEach(function (el) { io.observe(el); });
      var sweepT;
      window.addEventListener('scroll', function () {
        clearTimeout(sweepT);
        sweepT = setTimeout(function () {
          var h = window.innerHeight;
          rvs.forEach(function (el) {
            if (el.classList.contains('is-in')) return;
            var r = el.getBoundingClientRect();
            if (r.top < h && r.bottom > -h) reveal(el);
          });
        }, 160);
      }, { passive: true });
    }

    // Stage: pointer tilt on the bag (fine pointers), and a little depth on scroll for the rings,
    // disc and note chips.
    var hero = root.querySelector('.bsfx-hero');
    var stage = root.querySelector('[data-bsfx-stage]');
    var tilt = root.querySelector('[data-bsfx-tilt]');
    if (!reduce && hero && stage && tilt && fine) {
      hero.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - (r.left + r.width / 2)) / r.width, y = (e.clientY - (r.top + r.height / 2)) / r.height;
        x = Math.max(-0.6, Math.min(0.6, x)); y = Math.max(-0.6, Math.min(0.6, y));
        tilt.style.transform = 'rotateY(' + (x * 18).toFixed(2) + 'deg) rotateX(' + (-y * 12).toFixed(2) + 'deg)';
      });
      hero.addEventListener('pointerleave', function () { tilt.style.transform = ''; });
    }
    if (!reduce && stage) {
      var sTick = false;
      var onS = function () {
        if (sTick) return;
        sTick = true;
        requestAnimationFrame(function () {
          sTick = false;
          var y = Math.min(window.pageYOffset || 0, 900);
          stage.style.setProperty('--par', (-y * 0.12).toFixed(1) + 'px');
        });
      };
      window.addEventListener('scroll', onS, { passive: true });
      onS();
    }

    // Long layout hero (27 Oct 2026): the per-cup counts up from zero once the words have risen, and
    // the bean orbits follow the pointer a little on desktops. Everything else is CSS.
    if (root.classList.contains('bsfx--long') && !reduce) {
      if (pcEl) {
        var realPc = pcEl.textContent;
        var zeroPc = realPc.replace(/\d+(?:\.\d+)?/, function (n) { return n.indexOf('.') >= 0 ? '0.' + n.split('.')[1].replace(/\d/g, '0') : '0'; });
        pcEl.textContent = zeroPc;
        setTimeout(function () { tweenPc(realPc); }, 520);
      }
      if (hero && stage && fine) {
        hero.addEventListener('pointermove', function (e) {
          var r = stage.getBoundingClientRect();
          var x = (e.clientX - (r.left + r.width / 2)) / r.width, y = (e.clientY - (r.top + r.height / 2)) / r.height;
          stage.style.setProperty('--mx', Math.max(-0.6, Math.min(0.6, x)).toFixed(3));
          stage.style.setProperty('--my', Math.max(-0.6, Math.min(0.6, y)).toFixed(3));
        });
        hero.addEventListener('pointerleave', function () { stage.style.setProperty('--mx', '0'); stage.style.setProperty('--my', '0'); });
      }
    }

    // Roast-date track: "your bag" travels from day 0 to a few days in as the track scrolls into
    // view, then the day 7 to 30 window lights up.
    var track = root.querySelector('[data-bsfx-track]');
    if (track) {
      var tbag = track.querySelector('[data-bsfx-trackbag]');
      var rail = track.querySelector('.bsfx-track__rail');
      var DAY = 5 / 35;
      var setTrack = function (p) {
        p = Math.max(0, Math.min(1, p));
        if (tbag && rail) tbag.style.setProperty('--tx', (p * DAY * rail.getBoundingClientRect().width).toFixed(1) + 'px');
        track.classList.toggle('is-win', p >= 0.98);
      };
      if (reduce) {
        setTrack(1);
      } else {
        var tTick = false;
        var onT = function () {
          if (tTick) return;
          tTick = true;
          requestAnimationFrame(function () {
            tTick = false;
            var r = track.getBoundingClientRect(), h = window.innerHeight;
            setTrack((h * 0.9 - r.top) / (h * 0.55));
          });
        };
        window.addEventListener('scroll', onT, { passive: true });
        window.addEventListener('resize', onT);
        onT();
      }
    }

    // Taste hotspots: tap to open one note; on first view they open in turn once.
    var hots = qsa(root, '[data-bsfx-hot]');
    function closeHots(except) { hots.forEach(function (o) { if (o !== except) o.setAttribute('aria-expanded', 'false'); }); }
    hots.forEach(function (h) {
      h.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var open = h.getAttribute('aria-expanded') === 'true';
        closeHots(h);
        h.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
    if (hots.length) {
      document.addEventListener('click', function () { closeHots(null); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeHots(null); });
      var toured = false;
      onReveal.push(function (el) {
        if (toured || reduce || !el.classList.contains('bsfx-photo')) return;
        toured = true;
        hots.forEach(function (h, i) {
          setTimeout(function () { closeHots(h); h.setAttribute('aria-expanded', 'true'); }, 700 + i * 1300);
        });
        setTimeout(function () { closeHots(null); }, 700 + hots.length * 1300 + 400);
      });
    }

    // Review wall depth on phones: cards ease down in scale away from the centre of the row.
    var wall = root.querySelector('[data-bsfx-wall]');
    if (wall && !reduce) {
      var cards = qsa(wall, '.bsfx-card');
      var wTick = false;
      var depth = function () {
        wTick = false;
        if (wall.scrollWidth <= wall.clientWidth + 4) { cards.forEach(function (c) { c.style.transform = ''; }); return; }
        var r = wall.getBoundingClientRect(), cx = r.left + r.width / 2;
        cards.forEach(function (c) {
          var b = c.getBoundingClientRect(), off = (b.left + b.width / 2 - cx) / r.width;
          var d = Math.min(1, Math.abs(off));
          c.style.transform = 'scale(' + (1 - d * 0.08).toFixed(3) + ') rotate(' + (off * 2.2).toFixed(2) + 'deg)';
        });
      };
      wall.addEventListener('scroll', function () { if (!wTick) { wTick = true; requestAnimationFrame(depth); } }, { passive: true });
      window.addEventListener('resize', depth);
      depth();
    }

    // Accordion: one question open at a time.
    var items = qsa(root, '[data-bsfx-faq] details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
